var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscovery = function SvgDiscovery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    filter: "url(#discovery_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7AEB1",
    fillRule: "evenodd",
    d: "M23.228 2.768c-1.24-.11-2.756-.11-4.674-.11h-.108c-1.918 0-3.434 0-4.674.11-1.274.114-2.34.35-3.347.867q-.391.2-.761.44c-.951.613-1.689 1.418-2.424 2.465-.716 1.018-1.474 2.331-2.433 3.992l-.054.094c-.959 1.66-1.717 2.973-2.241 4.103-.539 1.16-.867 2.2-.923 3.331a9 9 0 0 0 0 .88c.056 1.13.384 2.171.923 3.331.524 1.13 1.282 2.442 2.24 4.103l.055.094c.959 1.66 1.717 2.974 2.433 3.992.735 1.047 1.473 1.852 2.424 2.466q.37.238.761.44c1.007.516 2.073.752 3.347.866 1.24.11 2.756.11 4.674.11h.108c1.918 0 3.434 0 4.674-.11 1.274-.114 2.34-.35 3.347-.867q.391-.2.761-.44c.951-.613 1.689-1.418 2.424-2.465.716-1.018 1.474-2.331 2.433-3.992l.054-.094c.959-1.66 1.717-2.973 2.241-4.103.538-1.16.867-2.2.923-3.332a9 9 0 0 0 0-.879c-.056-1.13-.385-2.171-.923-3.331-.524-1.13-1.282-2.443-2.24-4.103l-.055-.095c-.959-1.66-1.717-2.973-2.433-3.991-.736-1.047-1.473-1.852-2.424-2.466a9 9 0 0 0-.761-.44c-1.007-.516-2.073-.752-3.347-.866"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#discovery_svg__b)",
    d: "M23.228 2.768c-1.24-.11-2.756-.11-4.674-.11h-.108c-1.918 0-3.434 0-4.674.11-1.274.114-2.34.35-3.347.867q-.391.2-.761.44c-.951.613-1.689 1.418-2.424 2.465-.716 1.018-1.474 2.331-2.433 3.992l-.054.094c-.959 1.66-1.717 2.973-2.241 4.103-.539 1.16-.867 2.2-.923 3.331a9 9 0 0 0 0 .88c.056 1.13.384 2.171.923 3.331.524 1.13 1.282 2.442 2.24 4.103l.055.094c.959 1.66 1.717 2.974 2.433 3.992.735 1.047 1.473 1.852 2.424 2.466q.37.238.761.44c1.007.516 2.073.752 3.347.866 1.24.11 2.756.11 4.674.11h.108c1.918 0 3.434 0 4.674-.11 1.274-.114 2.34-.35 3.347-.867q.391-.2.761-.44c.951-.613 1.689-1.418 2.424-2.465.716-1.018 1.474-2.331 2.433-3.992l.054-.094c.959-1.66 1.717-2.973 2.241-4.103.538-1.16.867-2.2.923-3.332a9 9 0 0 0 0-.879c-.056-1.13-.385-2.171-.923-3.331-.524-1.13-1.282-2.443-2.24-4.103l-.055-.095c-.959-1.66-1.717-2.973-2.433-3.991-.736-1.047-1.473-1.852-2.424-2.466a9 9 0 0 0-.761-.44c-1.007-.516-2.073-.752-3.347-.866Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#discovery_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#discovery_svg__d)",
    fillRule: "evenodd",
    d: "M24.327 16.195c.913-2.218-1.304-4.435-3.522-3.522l-4.127 1.7a4.24 4.24 0 0 0-2.306 2.305l-1.699 4.127c-.913 2.218 1.304 4.435 3.522 3.522l4.127-1.7a4.24 4.24 0 0 0 2.306-2.305z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discovery_svg__b",
    x1: 1.578,
    x2: 33.212,
    y1: 2.657,
    y2: 36.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "discovery_svg__d",
    x1: 18.602,
    x2: 35.268,
    y1: 27.11,
    y2: 10.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "discovery_svg__a",
    width: 82.844,
    height: 80.685,
    x: -22.922,
    y: -21.843,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "discovery_svg__c",
    width: 25.099,
    height: 25.099,
    x: 9.207,
    y: 9.206,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.256,
    dy: 3.256
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.256
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.8 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1_4603",
    result: "shape"
  })))));
};
export { SvgDiscovery as ReactComponent };